import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState } from '../stores/types/types';
import { HomeNotification, NOTIFICATION_TYPES } from '../stores/reducers/home';
import { LoadNotifications, SetNotificationsSeen } from '../connection/home';

interface UseChatReturn {
    setChatNotificationsSeen: Function
}

const useChat = (): UseChatReturn => {
    const meeting = useSelector((state: GreenroomState) => state.SessionReducer.meeting);
    const token = useSelector((state: GreenroomState) => state.SessionReducer.token);

    const setChatNotificationsSeen = async () => {
        if(!token) {
            return;
        }

        const notifications = await LoadNotifications(token);
        const notificationIds = notifications.filter((notification: HomeNotification) => notification.notification
            && notification.meeting === meeting?.meeting
            && !notification.has_been_seen 
            && (notification.type == NOTIFICATION_TYPES.COMMENT_BASIC
            || notification.type == NOTIFICATION_TYPES.COMMENT_MENTION))
            .map((notification: HomeNotification) =>  notification.notification!);

        await SetNotificationsSeen(token, notificationIds);
    }

    return {
        setChatNotificationsSeen
    }
}

export default useChat;